import { Directive, ElementRef, HostListener, Optional } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[appNumericOnly]'
})
export class NumericOnlyDirective {

  constructor(private el: ElementRef, @Optional() private control: NgControl) {}

  @HostListener('input', ['$event'])
  onInput(event: Event) {
    const input = event.target as HTMLInputElement | null;
    const value = input?.value ?? '';
    const sanitizedValue = value
      .replace(/[\u0660-\u0669\u06f0-\u06f9]/g, c => (c.charCodeAt(0) & 0xf).toString())
      .replace(/[^0-9]/g, '');

    if (input) {
      input.value = sanitizedValue;
    }

    if (this.control?.control) {
      this.control.control.setValue(sanitizedValue, { emitEvent: false });
    }
  }

  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent): boolean {
    const allowedKeys = [
      'Backspace', 'Delete', 'Tab', 'Escape', 'Enter',
      'Home', 'End', 'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown',
    ];
    if (allowedKeys.includes(event.key) || event.ctrlKey || event.metaKey) return true;
    if (/^[0-9]$/.test(event.key)) return true;
    event.preventDefault();
    return false;
  }

  @HostListener('paste', ['$event'])
  onPaste(event: ClipboardEvent): void {
    event.preventDefault();
    const pasted = event.clipboardData?.getData('text') ?? '';
    const sanitized = pasted
      .replace(/[\u0660-\u0669\u06f0-\u06f9]/g, c => (c.charCodeAt(0) & 0xf).toString())
      .replace(/[^0-9]/g, '');
    const input = this.el.nativeElement as HTMLInputElement;
    const start = input.selectionStart ?? input.value.length;
    const end = input.selectionEnd ?? input.value.length;
    const next = input.value.slice(0, start) + sanitized + input.value.slice(end);
    input.value = next;
    if (this.control?.control) {
      this.control.control.setValue(next, { emitEvent: false });
    }
  }
}
